import { ArrowUpRight, Brain, Heart, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";
import { NEXT_ASSESSMENT_URL } from "../constants";

const pillars = [
  { icon: Heart, label: "Interests", desc: "What pulls you in and keeps you curious." },
  { icon: Brain, label: "Aptitude", desc: "Where your natural strengths actually lie." },
  { icon: Sparkles, label: "Personality", desc: "How you work, decide and grow best." },
];

export const NextAssessment = () => (
  <section
    id="next"
    data-testid="next-section"
    className="relative py-20 lg:py-28 bg-[#111111] overflow-hidden"
  >
    <div className="absolute top-0 right-0 w-[40rem] h-[40rem] rounded-full bg-[#F01E1F]/10 blur-3xl pointer-events-none" />
    <div className="absolute bottom-0 left-0 w-[30rem] h-[30rem] rounded-full bg-[#FE7815]/10 blur-3xl pointer-events-none" />

    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p
              data-testid="next-overline"
              className="text-xs sm:text-sm uppercase tracking-[0.3em] font-bold text-[#FE7815]"
            >
              YOUR STARTING POINT
            </p>
            <h2
              data-testid="next-heading"
              className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#FFFFFF]"
            >
              A clear direction. A stronger foundation.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[#FFFFFF]/60 leading-relaxed max-w-xl">
              Before choosing where to study, are you clear about the future you
              want to build? If you're unsure, NEXT by Movementor combines
              career assessment and mentoring to help you understand your
              strengths, explore career possibilities and give your study-abroad
              plans a clearer purpose.
            </p>
            <a
              href={NEXT_ASSESSMENT_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="next-assessment-cta-button"
              className="group mt-10 inline-flex items-center gap-2 text-base font-bold text-[#111111] px-8 py-4 rounded-full bg-gradient-to-r from-[#FE7815] to-[#FE7815] hover:-translate-y-1 hover:shadow-xl hover:shadow-orange-500/25 active:translate-y-0 transition-[transform,box-shadow] duration-300"
            >
              Explore NEXT
              <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-6 flex flex-col gap-4">
          {pillars.map((p, i) => (
            <Reveal key={p.label} delay={0.1 + i * 0.1}>
              <div
                data-testid={`next-pillar-${p.label.toLowerCase()}`}
                className="group flex items-start gap-5 bg-white/[0.04] backdrop-blur-md border border-white/10 rounded-2xl p-6 lg:p-8 hover:bg-white/[0.08] hover:border-[#FE7815]/40 transition-[background-color,border-color] duration-400"
              >
                <span className="text-2xl font-black text-outline-paper select-none">
                  0{i + 1}
                </span>
                <div className="w-11 h-11 shrink-0 rounded-xl bg-gradient-to-br from-[#FE7815] to-[#F01E1F] flex items-center justify-center">
                  <p.icon className="w-5 h-5 text-white" strokeWidth={2.2} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#FFFFFF]">
                    {p.label}
                  </h3>
                  <p className="mt-1 text-sm text-[#FFFFFF]/55">{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
